import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialog, MatTableDataSource, MatPaginator, MatSelect } from '@angular/material';
import { TranslateService } from '@ngstack/translate';
import { SubsidiaryContractEntryComponent } from '../subsidiary-contract-entry/subsidiary-contract-entry.component';
import { SubsidiaryContractService } from 'src/app/services/http/business/subsidiary/subsidiary-contract.service';
import { IConfirm } from 'src/app/interfaces/confirm';
import { ConfirmComponent } from 'src/app/components/confirm/confirm.component';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { SubsidiaryCompanyService } from 'src/app/services/http/business/subsidiary/subsidiary-company.service';
import { CompanyService } from 'src/app/services/http/business/company/company.service';
import { CIDService } from 'src/app/services/common/cid.service';
import { ICompany } from 'src/app/interfaces/company';

@Component({
  selector: 'app-subsidiary-contract-list',
  templateUrl: './subsidiary-contract-list.component.html',
  styleUrls: ['./subsidiary-contract-list.component.css']
})
export class SubsidiaryContractListComponent implements OnInit {
  customers = [];
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = [
    "customerTitle",
    "title",
    "contractDate",
    "coefficient",
    // "status",
    "roomCount",
    "function"
  ];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  pageSize: number;
  companyList: ICompany[];
  pageIndex: number;
  queryParams: any;
  showSearch: boolean = true;
  filter: any;
  companySelected: string;

  constructor(
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    private companyService: CompanyService,
    private cidService: CIDService,
    private subsidiaryContractService: SubsidiaryContractService,
    private subsidiaryCompanyService: SubsidiaryCompanyService,
  ) {
  }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.filter = params["params"];
      if (this.filter.CustomerId) {
        this.showSearch = false;
      }

    });

    this.getCompanyList();
    this.getCustomerList();

  }

  getCustomerList() {
    this.subsidiaryCompanyService.getCustomerListCombo().subscribe(res => {
      this.customers = res;
    });
  }

  refresh() {
    this.subsidiaryContractService.getCustomerContractList(this.filter).subscribe(
      res => {
        this.paginator.pageSize = 10;
        this.paginator.length = res.Total;
        this.pageIndex = 0;
        this.paginator.length = res.Total;
        this.dataSource = new MatTableDataSource(res.DataList);
      }
    );
  }

  paginatorEvent(event) {
    this.subsidiaryContractService.getCustomerContractList(this.filter, event.pageIndex + 1, event.pageSize)
      .subscribe(res => {
        this.pageSize = event.pageSize;
        this.paginator.length = res.Total;
        this.pageIndex = event.pageIndex + 1;
        this.dataSource = new MatTableDataSource(res.DataList);
      });
  }
  setFilter(event: MatSelect) {

    this.filter = {
      CustomerId: event.value
    }
    this.getCompanyList();
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
      if (this.companyList.length >= 0) {
        this.getDefualtList(this.companyList[0]);
      }
    });
  }

  getDefualtList(item: any): void {
    this.cidService.setCID(item.CompanyEncryptId);
    this.companySelected = item.CompanyEncryptId;
    this.refresh();
  }

  showClasses(contractId: number) {
    console.log(contractId);

  }

  addCustomerContract() {

    this.dialog
      .open(SubsidiaryContractEntryComponent, {
        width: "750px",
        data: this.filter,
        disableClose: true
      })
      .afterClosed()
      .subscribe(() => {
        this.paginatorEvent({ pageSize: this.pageSize, pageIndex: this.pageIndex });
      });
  }

  setCid(e: MatSelect) {
    this.cidService.setCID(e.value);
    this.refresh();
  }

  editCustomerContract(params: any) {
    this.dialog.open(SubsidiaryContractEntryComponent, {
      width: "750px",
      data: params,
      disableClose: true
    })
      .afterClosed()
      .subscribe(() => {
        this.paginatorEvent({ pageSize: this.pageSize, pageIndex: this.pageIndex });
      });
  }

  addRoom(element){
    let confirm: IConfirm = {
      accept: true,
      message: 'آیا مایل به اضافه کردن اتاق برای این قرارداد هستید؟',
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "250px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      var model: any = {
        Id: element.Id
      };
      if (result) {
        this.subsidiaryContractService.customerContractAddRoom(model).subscribe(
          () => {
            this.snackBar.OpenSnackBar(
              'ایجاد اتاق با موفقیت انجام شد',
              "ok",
              5000,
              SoundEnum.beep
            );
            this.paginatorEvent({ pageSize: this.pageSize, pageIndex: this.pageIndex });
          },
          () => {
            this.snackBar.OpenSnackBar(
              'خطا در ایجاد اتاق برای قرارداد اقماری',
              "ok",
              5000,
              SoundEnum.beep
            );
          }
        );
      }
    });

  }
  delete(data: any): void {
    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get("confirm.delete", {
        name: this.translate.get("label.contract") + " " + "'" + data.Title + "'"
      }),
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "250px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      var model: any = {
        Id: data.Id
      };
      if (result) {
        this.subsidiaryContractService.customerContractDelete(model).subscribe(
          () => {
            this.snackBar.OpenSnackBar(
              this.translate.get("success.deleteContract"),
              "ok",
              5000,
              SoundEnum.beep
            );
            this.paginatorEvent({ pageSize: this.pageSize, pageIndex: this.pageIndex });
          },
          () => {
            this.snackBar.OpenSnackBar(
              this.translate.get("error.deleteContract"),
              "ok",
              5000,
              SoundEnum.beep
            );
          }
        );
      }
    });
  }

  toggleDisableAddPerson(data: any) {
    var model: any = {
      CustomerContracId: data.Id
    };
    this.subsidiaryContractService.changeCustomerContractPersonAddState(model).subscribe(() => {
      this.snackBar.OpenSnackBar(
        'تغییر وضعیت با موفقیت انجام شد',
        "ok",
        5000,
        SoundEnum.beep
      );
      this.paginatorEvent({ pageSize: this.pageSize, pageIndex: this.pageIndex });
    })
  }

}
